import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomModal from '../../Components/CustomModal/CustomModal';
import { useAdminLoginMutation } from '../../features/auth/authApi';
import ForgetPasswordModalContent from './ForgetPasswordModalContent';

const AdminLogin = () => {
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false);
    const { register, reset, handleSubmit, watch, formState: { errors } } = useForm();
    const [adminLogin, { isError, isLoading, isSuccess, error, data }] = useAdminLoginMutation()

    const onSubmit = data => {
        adminLogin(data)
    };

    useEffect(() => {
        if (isSuccess) {
            if (data.user.role === 'admin') {
                navigate('/admin/dashboard')
                toast.success("Welcome to admin dashboard")
            } else {
                toast.error("You are not Admin!")
                reset()
            }

        }
        if (isError) {
            if (error.status === 400) {
                toast.error(error?.data)

                reset()
            } else {

                toast.error('User not found! Try again with admin account')
            }
        }
    }, [isSuccess, isError])

    const handleOpen = () => {
        setIsOpen(pre => !pre)
    }
    return (
        <>
            <CustomModal open={isOpen} setOpen={setIsOpen}>
                <ForgetPasswordModalContent setIsOpen={setIsOpen}></ForgetPasswordModalContent>
            </CustomModal>
            <section className="py-6 bg-primary h-screen grid place-items-center">
                <div className="mx-auto max-w-md px-5 lg:px-0">
                    <div>
                        <Link to='/'>
                            <img className="h-12 mx-auto" src="/image/learningportal.svg" />
                        </Link>
                        <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                            Sign in to Admin Account
                        </h2>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-6" >
                        <input type="hidden" name="remember" value="true" />
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="email-address" className="sr-only">Email address</label>
                                <input id="email-address" name="email" type="email" {...register("email", { required: true })} autoComplete="email" required
                                    className="login-input rounded-t-md" placeholder="Email address" />
                            </div>
                            <div>
                                <label htmlFor="password" className="sr-only">Password</label>
                                <input {...register("password", { required: true })} id="password" name="password" type="password" autoComplete="current-password" required
                                    className="login-input rounded-b-md" placeholder="Password" />
                            </div>
                        </div>

                        <div className="flex items-center justify-end">
                            <div className="text-sm">
                                <button type='button' onClick={handleOpen} className="font-medium text-violet-600 hover:text-violet-500">
                                    Forgot your password?
                                </button>
                            </div>
                        </div>

                        <div>
                            <button type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                                Sign in
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
};

export default AdminLogin;